import styled from 'styled-components';
import { BodyWrapper } from '@app/ui/pages/landing-page/body/body.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FooterWrapper = styled.div<any>`
  background: #f7f8fc;
  min-height: 120px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FooterWrapperChild = styled(BodyWrapper as any)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FooterBlockWrapper = styled.div<any>`
  padding: 20px 0;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: none;
      opacity: 0.8;
    }
  }
`;
